/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Country } from '@app/settings/countries/countries.model';
import { CountriesSeoFormComponent } from '@app/settings/countries/countries-seo-form/countries-seo-form.component';

@Injectable({
  providedIn: 'root',
})
export class CountriesSeoFormService {
  constructor(private modalService: NgbModal) {}

  public open(country: null | Country = null): Promise<any> {
    const modal = this.modalService.open(CountriesSeoFormComponent, { size: 'xl' as 'lg' });
    modal.componentInstance.country = country;
    return modal.result;
  }
}
